
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"238","height":"337","viewBox":"0 0 238 337","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#D2232A","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M35.74 66.404l16.407 21.18-16.406 21.251-16.764-21.25z"}}),_c('text',{attrs:{"font-family":"Roboto-Bold, Roboto","font-size":"59","font-weight":"bold","transform":"translate(13.5 2.404)"}},[_c('tspan',{attrs:{"x":"5.575","y":"55"}},[_v('8')])]),_c('path',{attrs:{"d":"M202.264 270.404l-16.407-21.18 16.407-21.25 16.763 21.25z"}}),_c('text',{attrs:{"font-family":"Roboto-Bold, Roboto","font-size":"59","font-weight":"bold","transform":"rotate(180 112.252 167.202)"}},[_c('tspan',{attrs:{"x":"5.575","y":"55"}},[_v('8')])]),_c('g',[_c('path',{attrs:{"d":"M90.256 278.404L79.35 264.428l10.906-14.024 11.144 14.024zM148.506 278.404L137.6 264.428l10.906-14.024 11.144 14.024zM148.744 154.404l10.906 13.977-10.906 14.023-11.144-14.023zM90.494 154.404l10.906 13.977-10.906 14.023-11.144-14.023zM148.744 58.404l10.906 13.977-10.906 14.023L137.6 72.381zM90.494 58.404L101.4 72.381 90.494 86.404 79.35 72.381z"}}),_c('g',[_c('path',{attrs:{"d":"M119.619 105.104l10.906 15.974-10.906 16.026-11.144-16.026z"}})]),_c('g',[_c('path',{attrs:{"d":"M119.381 231.704l-10.906-15.973 10.906-16.027 11.144 16.027z"}})])])])])
          )
        }
      }
    